import React, { useEffect, useState } from 'react';
import propTypes from 'prop-types';
import Text from '../../typography'
import styled from 'styled-components';
import {theme} from '../../../themes/default-theme';
import NewPostcodePopup from '../../ui/NewPostcodePopup';
import ReactHtmlParser from 'react-html-parser';

const Wrapper = styled.div`
    
`

const Container = styled.div`
    max-width: 1400px;
    margin: auto;
    ${props => props.hide == 'show' && `
        margin-bottom: 35px;
        ${theme.breakpoints.down('sm')} { 
            margin-top: 40px;
        }
    `}
`
const LocationContainer = styled.div`
    margin-bottom: 20px;
    ${theme.breakpoints.up('md')} { 
        > div, > a {
            margin-right: 3px;
            font-size: 16px;
            line-height: 23px;
            display: inline-block;
            color: #758094;
        }
    }
    ${theme.breakpoints.down('sm')} {
        > div, > a {
            margin-right: 3px;
            font-size: 14px;
            line-height: 23px;
            display: inline-block;
            color: #758094;
        }
    }
`
const FooterNote = styled.div`
    > div {
        font-size: 10px;
        line-height: 16px;
        color: #2E3238;
    }
`

const ModelFooter = (props) => {

  const {
    text,
    dealers,
    countryProps,
    getCurrentSetSetLocation,
    openPostcodePopup,
    setOpenPostcodePopup,
    hide,
    staticData
  } = props;

  const SelectedDealer = typeof window != 'undefined' && window.localStorage.getItem('buildPriceDealer') ?  typeof window != 'undefined' && window.localStorage.getItem('buildPriceDealer') : typeof window != 'undefined' && window.localStorage.getItem('dealer') ? typeof window != 'undefined' && window.localStorage.getItem('dealer') : null
  const dealerTitle = process.browser && process.env.DEALER_SITE ? window.staticly.dealerData.name : "{{data.template.dealer.name}}";
  const [postcodeOpen, setPostcodeOpen] = useState(SelectedDealer ? false : true);
  const [SelectedDealerState, setSelectedDealerState] = useState(null);
  const [getLocation, setGetLocation] = useState({});

  const handlePostcodePopup = (e) => {
        e.preventDefault();
        setPostcodeOpen(true);
  } 

  const handlePostcodeStatus = () => {
    setPostcodeOpen(false); 
    setOpenPostcodePopup(false);
  } 

  const getCurrentLocation = (currentLocation) => {
    setGetLocation(currentLocation)
    getCurrentSetSetLocation(currentLocation);
  }
  useEffect(() => {
    setSelectedDealerState(
        typeof window != 'undefined' && window.localStorage.getItem('buildPriceDealer') ?  typeof window != 'undefined' && window.localStorage.getItem('buildPriceDealer') : typeof window != 'undefined' && window.localStorage.getItem('dealer') ? typeof window != 'undefined' && window.localStorage.getItem('dealer') : null
    )
  })
  useEffect(() => {
    setGetLocation(SelectedDealerState);
    getCurrentSetSetLocation(SelectedDealerState);
  }, [SelectedDealerState])

  useEffect(() => {
    openPostcodePopup &&
    setPostcodeOpen(openPostcodePopup)
  }, [openPostcodePopup])
  
  return (
    <Wrapper>
        <Container type={hide ? 'hide' : 'show'}>
            {process.env.DEALER_SITE !== true &&
                postcodeOpen &&
                    <NewPostcodePopup 
                        dealers={dealers}
                        countryProps={countryProps}
                        postcodeStatus={handlePostcodeStatus}
                        getCurrentSetLocation={getCurrentLocation}
                        staticData={staticData ? true : false}
                    />
            }
            {process.env.DEALER_SITE !== true ? 
                (!hide &&
                    <>
                        <LocationContainer>
                            {getLocation &&
                                <>
                                    <Text variant="body2" weight={700}>Dealer:</Text>
                                    {getLocation && typeof getLocation == 'string' &&  JSON.parse(getLocation).data &&  JSON.parse(getLocation).title && <Text variant="body2">{ JSON.parse(getLocation).title},</Text>}
                                    {getLocation && typeof getLocation == 'string' &&  JSON.parse(getLocation).data &&  JSON.parse(getLocation).data.contact?.suburb && <Text variant="body2">{ JSON.parse(getLocation).data.contact.suburb},</Text>}
                                    {getLocation && typeof getLocation == 'string' &&  JSON.parse(getLocation).data &&  JSON.parse(getLocation).data.contact?.state && <Text variant="body2">{ JSON.parse(getLocation).data.contact.state},</Text>}
                                    {getLocation && typeof getLocation == 'string' &&  JSON.parse(getLocation).data &&  JSON.parse(getLocation).data.contact?.postcode && <Text variant="body2">{ JSON.parse(getLocation).data.contact.postcode}</Text>}
                                </>
                            }
                            {!staticData && <a href="#" onClick={(e) => {handlePostcodePopup(e)}}>{getLocation ? 'Change' :'Add your postcode first'}</a>}
                        </LocationContainer>
                        {text &&
                            <FooterNote>
                                <Text variant="body2">{ReactHtmlParser(text)}</Text>
                            </FooterNote>
                        }
                    </>
                )
            :
                
                !hide &&
                    <>
                        {dealerTitle &&
                            <LocationContainer>
                                <>
                                    <Text variant="body2" weight={700}>Dealer:</Text>
                                    <Text variant="body2">{ dealerTitle}</Text>
                                </>
                            </LocationContainer>
                        }
                        {text &&
                            <FooterNote>
                                <Text variant="body2">{ReactHtmlParser(text)}</Text>
                            </FooterNote>
                        }
                    </>
            }
        </Container>
    </Wrapper>
  )
}
  
ModelFooter.propTypes = {
    text: propTypes.string,
    dealers: propTypes.array,
    postcode: propTypes.string,
    getCurrentSetSetLocation: propTypes.func,
    openPostcodePopup: propTypes.bool,
    setOpenPostcodePopup: propTypes.func,
    hide: propTypes.bool,
    staticData: propTypes.bool
}
  
ModelFooter.defaultProps = {
    text: null,
    dealers: [],
    postcode: '',
    getCurrentSetSetLocation: () => {},
    openPostcodePopup: false,
    setOpenPostcodePopup: () => {},
    hide: false,
    staticData: false
}
  
export default ModelFooter